import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import ButtonWithToolTip from 'components/ButtonWithToolTip';
import messages from 'containers/QuestionnairePage/QuestionGroup/ABTest/Concepts/messages';

const Concept = ({ concept, conceptIndex, intl }) => (
  <div
    className="position-absolute"
    style={{
      top: 12,
      left: 12,
      bottom: 12,
      right: 3,
    }}
  >
    <div className="display-flex flex-items-center">
      <input
        type="text"
        readOnly
        maxLength="40"
        value={concept.name}
        placeholder={intl.formatMessage(messages.conceptPlaceholder, {
          index: conceptIndex + 1,
        })}
        className="flex-1 background-grey-4 color-grey-10 color-grey-8-placeholder text-size-secondary outline-none border-radius-level-1 padding-xs"
      />
      <ButtonWithToolTip disabled tooltip={messages.remove} iconType="close" />
    </div>
  </div>
);

Concept.propTypes = {
  concept: PropTypes.object,
  conceptIndex: PropTypes.number,
  intl: PropTypes.object,
};

export default injectIntl(Concept);
